module.exports = __webpack_public_path__ + "icon_alert_no_data.8aaba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_alert_no_data.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_alert_no_data.svg
// module chunks = main